// window.URL_API = 'http://208.97.141.22/api/'
window.URL_API = 'https://api.sprinta.com.br/'
window.URL_ASSETS_BASE = 'https://www.sprinta.com.br/'
window.URL_BASE_OLD = 'https://www.sprinta.com.br/'



// WEBPACK FOOTER //
// ./src/_config.js